import Snackbar from "@mui/material/Snackbar";
import { useState, createContext } from "react";
import * as React from "react";
import MuiAlert from "@mui/material/Alert";

const context = createContext({});
const Provider = context.Provider;

const settings = { state: false, message: "", type: "error" };

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Services = ({ children }) => {
  const [alertError, setAlertError] = useState(settings);
  const [loader, setLoader] = useState({
    visible: false,
    message: "Please wait...",
  });

  const handleClose = () => {
    setAlertError((prev) => ({ ...prev, state: false }));
  };

  const alertMessage = (msg, type) => {
    setAlertError((prev) => ({
      ...prev,
      state: true,
      message: msg,
      type: type,
    }));
  };

  const loaderShow = (value = true, message = "") => {
    setLoader({ visible: value, message });
  };

  return (
    <Provider value={{ alertMessage, loaderShow }}>
      <Snackbar
        open={alertError.state}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertError.type}
          sx={{ width: "100%" }}
        >
          {alertError.message}
        </Alert>
      </Snackbar>

      {/* Custom Shipment Tracking Loader */}
      {loader.visible && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-[9999]">
          <div
            className="bg-white rounded-2xl shadow-2xl flex flex-col items-center text-center"
            style={{
              padding: "2rem 2.5rem",
              minWidth: "300px",
              maxWidth: "360px",
              gap: "0.5rem",
            }}
          >
            {/* Title */}
            <h2 className="text-[#D40511] font-bold text-3xl leading-tight">
              Hang tight!
            </h2>
            <p className="text-gray-600 text-base -mt-1">
              Your delivery is on the move…
            </p>

            {/* Spinner with Box Icon */}
            <div
              className="relative my-2 flex items-center justify-center"
              style={{ width: "185px", height: "185px" }}
            >
              <svg
                className="absolute inset-0 w-full h-full animate-spin"
                viewBox="0 0 185 185"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ animationDuration: "1.2s" }}
              >
                {/* Grey full circle */}
                <circle
                  cx="92.5"
                  cy="92.5"
                  r="88"
                  stroke="#e5e7eb"
                  strokeWidth="5"
                  fill="none"
                />
                {/* Red arc — about 1/4 circle */}
                <circle
                  cx="92.5"
                  cy="92.5"
                  r="88"
                  stroke="#D40511"
                  strokeWidth="5"
                  fill="none"
                  strokeLinecap="round"
                  strokeDasharray="138 415"
                  strokeDashoffset="0"
                />
              </svg>

              {/* Box image in center */}
              <img
                src="/InternationalExpress/redboxx.jpg"
                alt="Shipment Box"
                className="object-contain rounded"
                style={{ width: "160px", height: "160px" }}
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.nextSibling.style.display = "block";
                }}
              />
              <span className="text-3xl hidden" style={{ display: "none" }}>
                📦
              </span>
            </div>

            {/* Bottom label */}
            <p className="text-gray-500 text-base">
              We're tracking your shipment in real time
            </p>
          </div>
        </div>
      )}

      {children}
    </Provider>
  );
};

export const ServicesProvider = context;
export default Services;
